import React from "react";

import { faPen } from "@fortawesome/pro-solid-svg-icons/faPen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown, { DropDownProps } from "antd/es/dropdown";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";

import getMarkerShapeIcon from "@app/scene/map/utils/getMarkerShapeIcon";

import getEditIconPositionByShape from "./getOffsetByShape";
import styles from "./ShapeDropdown.module.scss";
import ShapePanel, { ShapePanelProps } from "./ShapePanel";

interface Props extends Omit<DropDownProps, "overlay"> {
  onChange?: (shape: MarkerShape) => void;
  shapePanelProps?: Omit<ShapePanelProps, "onChange" | "value">;
  value?: MarkerShape;
}

const ShapeDropdown: React.FC<Props> = ({
  children,
  onChange,
  shapePanelProps,
  value,
  ...props
}) => {
  const intl = useIntl();
  const shapeIcon = value ? getMarkerShapeIcon(value) : undefined;

  return (
    <Dropdown
      overlay={
        <ShapePanel
          className={styles.shapePanel}
          onChange={onChange}
          value={value}
          {...shapePanelProps}
        />
      }
      placement="bottomLeft"
      trigger={["click"]}
      {...props}
    >
      {children ?? (
        <Tooltip
          title={intl.formatMessage({
            id: "shapeDropdown.hoverTooltip",
            defaultMessage: "Change Shape",
            description: "A tooltip to show when cursor is over the edit icon",
          })}
        >
          <div className={styles.currentShape}>
            {shapeIcon && <FontAwesomeIcon className={styles.shapeIcon} icon={shapeIcon} />}
            <FontAwesomeIcon
              className={styles.editIcon}
              icon={faPen}
              style={getEditIconPositionByShape(value)}
            />
          </div>
        </Tooltip>
      )}
    </Dropdown>
  );
};

export default ShapeDropdown;
